<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div>
          <h4 class="text-center">Administración de Usuarios</h4>
          <hr class="horizontal dark" />
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-start">
              <IconField>
                <InputIcon class="pi pi-search" @click="applyFilter" style="cursor: pointer;"/>
                <InputText v-model="dataTableDetail.filter" placeholder="Search" @keyup.enter="applyFilter" v-tooltip="'Introduce tu filtro y presiona Enter'"/>
              </IconField>
            </div>
            <div class="d-flex justify-content-end">
              <a class="btn btn-addiuva-dark" @click="iniciarCrearUsuario()">
                <i class="fas fa-plus"></i> &nbsp; Crear Nuevo Usuario
              </a>
            </div>
          </div>
          <Toast />
          <!-- stripedRows -->
          <DataTable
            :value="usuarios"
            :lazy="true"
            :totalRecords="totalRecords"
            :loading="loading"
            @lazyLoad="listUsers"
            @page="onPageChange"
            @sort="onSort"
            :paginator="true"
            :rows="10"
            :rowsPerPageOptions="[5, 10, 20, 50]"
            tableStyle="min-width: 50rem"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="{currentPage} de {totalPages}"
          >
            <template #empty> <div class="text-gray">No hay usuarios que mostrar. </div></template>
            <Column field="user_name" header="Usuario" sortable ></Column>
            <Column field="rol_nombre" header="Rol" sortable ></Column>
            <Column field="status" header="Estado" sortable >
                <template #body="{ data }">
                    <Tag :value="(data.status == 1  ? 'ACTIVO' : 'INACTIVO')" :severity="getSeverity(data.status)" rounded/>
                </template>
            </Column>
            <Column field="company" header="Acción" style="width: 5%">
              <template #body="{ data }">
                <SplitButton label="Acciones" icon="fas fa-ellipsis-h" :model="data.items" menuButtonIcon="fas fa-ellipsis-h"  text v-if="data.items.length > 0" />
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
    <!-- Modal Dialogs -->
    <!-- Resetear Contraseña -->
    <Dialog v-model:visible="resetear.visible" modal header="Header" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <template #header>
          <div class="inline-flex align-items-center justify-content-center gap-2">
            <h5 class="text-bold white-space-nowrap text-addiuva-dark">Resetear Contraseña</h5>
          </div>
      </template>
      <div class="row">
        <div class="col-md-12">
          Esta seguro de Resetar la contraseña del usuario <b>{{resetear.nombres}} {{resetear.apellidos}}</b>? <br>
          <small>Se le enviara un correo electrónico a <b>{{resetear.email}}</b> xon su nueva contraseña temporal, una vez inicie sesión se le pedira cambiar su contraseña.</small>
        </div>
      </div>
      <template #footer>
        <button class="btn btn-light" style="margin-right:1rem;" @click="closeModalResetear()">
          <i class="fas fa-times pr-1"></i> Cancelar
        </button>
        <Button class="btn btn-addiuva-dark" type="button" label="Resetear Contraseña" icon="fas fa-unlock-alt pr-1" :loading="loadingButton" @click="resetearPassword" />
      </template>
    </Dialog>
    <!-- Crear/Editar Usuario -->
    <Dialog v-model:visible="editar.visible" modal header="Header" :style="{ width: '40%' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <template #header>
        <div class="flex-container">
          <div class="flex-item-left"><h5 class="text-bold text-addiuva-dark" id="title-edit">{{editar.title.toUpperCase()}}</h5></div>
          <div class="flex-item-right">
            <label for="editar-status">Activo</label>
            <div class="pt-1">
              <InputSwitch v-model="editar.status" id="editar-status"/>
            </div>
          </div>
        </div>
      </template>
      <div class="row" style="min-height: 30vh;">
        <div class="col-2"></div>
        <div class="col-8">
          <label for="user_name">Usuario <span class="text-danger">*</span></label>
          <InputText id="user_name" class="form-control" v-model="editar.user_name"/>
          <label for="apellidos">Rol <span class="text-danger">*</span></label>
          <vue-select
            :options="rolOptions"
            label="text"
            v-model="editar.id_rol"
            :reduce="(option) => option.value"
          ></vue-select>
          <div class="mt-3" v-if="editar.id">
            <label for="editar-status">Cambiar Contraseña</label>
            <div class="pt-1">
              <InputSwitch v-model="editPassword" id="editar-status"/>
            </div>
          </div>
          <div v-if="editPassword">
            <label for="passwordLogin">Nueva Contraseña <span class="text-danger">*</span></label>
            <Password v-model="editar.password" placeholder="Contraseña" :feedback="false" toggleMask class="w-100" id="passwordLogin"/>
            <label for="rePasswordLogin">Confirmar Contraseña <span class="text-danger">*</span></label>
            <Password v-model="editar.passwordConfirm" placeholder="Confirmar Contraseña" :feedback="false" toggleMask class="w-100" id="rePasswordLogin"/>
          </div>
        </div>
        <div class="col-2"></div>
      </div>
      <template #footer>
        <button class="btn btn-light" style="margin-right:1rem;" @click="closeModal()">
          <i class="fas fa-times pr-1"></i> Cancelar
        </button>
        <button class="btn btn-addiuva-dark" @click="editarUsuario" v-if="editar.id">
          <i class="fas fa-pen pr-1"></i> Editar
        </button>
        <button class="btn btn-addiuva-dark" @click="crearUsuario" v-if="!editar.id">
          <i class="fas fa-save pr-1"></i> Guardar
        </button>
      </template>
    </Dialog>
  </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import VueSelect from "vue-select";
import Tag from 'primevue/tag';
import Toast from 'primevue/toast';
import SplitButton from 'primevue/splitbutton';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import InputSwitch from 'primevue/inputswitch';
import Button from 'primevue/button';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import axios from 'axios';
import authHeader from '../services/auth-header';
import Password from 'primevue/password';
// import moment from "moment"
export default {
  name: "Administración de Usuarios",
  components: {
    VueSelect,
    DataTable,
    Column,
    Tag,
    Toast,
    SplitButton,
    Button,
    Dialog,
    InputText,
    InputSwitch,
    IconField,
    InputIcon,
    Password
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      showProfileDropdown: false,
      usuarios: [],
      resetear: {
        visible: false,
        id: null,
        nombres: null,
        apellidos: null,
        email: null
      },
      editar: {
        visible: false,
        title: null,
        id: null,
        user_name: null,
        password: null,
        id_rol: null,
        rol_nombre: null,
        status: null,
      },
      editPassword: false,
      rolOptions: [],
      agenciaOptions: [],
      basicConfigDatePicker: {
        "language": "es",
        "full-month-name":true,
        "monday-first": true,
        "iconWidth": "18",
        "iconHeight": "18",
        "use-utc": true,
      },
      loadingButton: false,
      loading: false,
      totalRecords: 0,
      dataTableDetail: {
        filter: null,
        page: 0,
        rows: 10,
        first: 0,
        sortField: null,
        sortOrder: null,
      }
    };
  },
  methods: {
    onPageChange(event){
      this.dataTableDetail.page = event.page;
      this.dataTableDetail.first = event.first;
      this.dataTableDetail.rows = event.rows;
      // Llama a la función para cargar los datos con los nuevos parámetros de paginación
      this.listUsers();
    },
    onSort(event){
      this.dataTableDetail.sortField = event.sortField;
      this.dataTableDetail.sortOrder = event.sortOrder;
      // Llama a la función para cargar los datos con los nuevos parámetros de orden
      this.listUsers();
    },
    applyFilter() {
      // Llama a la función para cargar los datos con los nuevos parámetros de filtro
      this.listUsers();
    },
    async listUsers() {
      this.usuarios = [];
      this.loading = true;
      // Send Data by Axios
      let url = this.API_URL + "/usuarios";
      await axios({
        url: url,
        method: 'get',
        headers: authHeader(),
        params: {
          page: this.dataTableDetail.page,
          rows: this.dataTableDetail.rows,
          first: this.dataTableDetail.first,
          sortField: this.dataTableDetail.sortField,
          sortOrder: this.dataTableDetail.sortOrder,
          filter: this.dataTableDetail.filter
        }
      })
      .then(response => {
        if (response.data.status) {
            let data = response.data.data;
            let usuarios = [];
            data.forEach(a => {
              usuarios.push({
                id: a.id ?? '',
                user_name: a.user_name ?? '',
                id_rol: a.id_rol ?? '',
                rol_nombre: a.rol_nombre ?? '',
                status: a.status ?? 0,
              });
            });
            usuarios.forEach(user => {
              user.items = this.subMenuDefault(user);
            });
            this.usuarios = usuarios;
            this.loading = false;
            this.totalRecords = usuarios.length;
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    getRoles() {
      this.rolOptions = [];
      // Send Data by Axios
      let url = this.API_URL + "/roles";
      axios({
        url: url,
        method: 'get',
        data: {},
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            let roles = [];
            response.data.data.forEach(element => {
              roles.push({ text: element.nombre, value: element.id });
            });
            this.rolOptions = roles
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    subMenuDefault(data) {
      let items = [
        {
          label: 'Editar',
          icon: 'fas fa-pen',
          command: () => {
              this.iniciarEdicion(data)
          }
        },
        // {
        //   label: 'Resetear Contraseña',
        //   icon: 'fas fa-unlock-alt',
        //   command: () => {
        //       this.iniciarResetear(data);
        //   }
        // }
      ];
      return items;
    },
    getSeverity(status) {
      let severity = null;
      if (status == true) severity = "success";
      if (status == false) severity = "danger";
      return severity;
    },
    capitalize(str) {
      const str2 = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      return str2;
    },
    // Resetear Contraseña
    iniciarResetear(data) {
        this.resetear.visible = true,
        this.resetear.id = data.id
        this.resetear.nombres = data.nombres
        this.resetear.apellidos = data.apellidos
        this.resetear.email = data.email
    },
    closeModalResetear() {
      this.resetear = {
        visible: false,
        id: null,
        nombres: null,
        apellidos: null,
        email: null
      };
    },
    resetearPassword() {
      if (this.resetear.id == null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error, datos no encontrados', life: 3000 });
        return true;
      }
      let payload = {
        "id_usuario": this.resetear.id
      }
      // Send Data by Axios
      let url = this.API_URL + "/usuarios/resetContrasena";
      this.loadingButton = true;
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        this.loadingButton = false;
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'Se envío un email al usuario con su nueva contraseña temporal.', life: 3000 });
            this.closeModalResetear();
            this.listUsers()
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    // Edicion
    iniciarEdicion(data) {
      this.editar = {
        visible: true,
        title: 'Editar Usuario',
        id: data.id,
        user_name: data.user_name,
        id_rol: data.id_rol,
        password: null,
        passwordConfirm: null,
        status: data.status == 1 ? true : false
      };
      this.editPassword = false;
      this.getRoles();
    },
    closeModal() {
      this.editar = {
        visible: false,
        title: null,
        id: null,
        user_name: null,
        id_rol: null,
        password: null,
        passwordConfirm: null,
        status: null,
      };
    },
    editarUsuario() {
      if (this.editar.id == null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error, datos no encontrados', life: 3000 });
        return true;
      }
      let payload = {
        "user_name": this.editar.user_name,
        "status": this.editar.status == true ? 1 : 0,
        "id_rol": this.editar.id_rol,
      };
      if (this.editPassword) {
        if (this.editar.password == null || this.editar.passwordConfirm == null) {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Debe ingresar y confirmar la nueva contraseña.', life: 3000 });
          return true;
        }
        if (this.editar.password !== this.editar.passwordConfirm) {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Las contraseñas no coinciden.', life: 3000 });
          return true;
        }
        payload.password = btoa(this.editar.password);
      }
      // Send Data by Axios
      let url = this.API_URL + "/usuarios/" + this.editar.id;
      axios({
        url: url,
        method: 'put',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'La Edición fue procesada exitosamente', life: 3000 });
            this.closeModal();
            this.listUsers()
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    crearUsuario() {
      if (this.editar.id != null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error.', life: 3000 });
        return true;
      }
      if (this.editar.password == null || this.editar.passwordConfirm == null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Debe ingresar y confirmar la nueva contraseña.', life: 3000 });
        return true;
      }
      if (this.editar.password !== this.editar.passwordConfirm) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Las contraseñas no coinciden.', life: 3000 });
        return true;
      }
      let payload = {
        "user_name": this.editar.user_name,
        "password": btoa(this.editar.password),
        "id_rol": this.editar.id_rol,
        "status": this.editar.status == true ? 1 : 0,
      }
      // Send Data by Axios
      let url = this.API_URL + "/usuarios";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'El usuario fue creado exitosamente', life: 3000 });
            this.closeModal();
            this.listUsers()
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    // Restauración
    iniciarCrearUsuario() {
      this.getRoles();
      this.editar = {
        visible: true,
        title: 'Crear Usuario',
        id: null,
        user_name: null,
        password: null,
        passwordConfirm: null,
        id_rol: null,
        status: true,
      };
      this.editPassword = true;
    },
    formatDate: function (date) {
      let aDate = date.split('/');
      return new Date(aDate[2], parseInt(aDate[1])-1, aDate[0]);
    },
    validateRoute(){
      let menus = this.getProfileMe.data.menu.filter( menu => {
        return (menu.path.toLowerCase().indexOf(this.$route.path.substring(1)) != -1);
      });
      if ( menus.length == 0 ) {
        this.$router.push({name: 'Home'});
      }
    }
  },
  computed: {
    getProfileMe() {
      return this.$store.getters["profile/me"];
    }
  },
  mounted() {
    this.validateRoute();
    this.listUsers();
  }
};
</script>
<style>
  .p-splitbutton-defaultbutton{
    display: none !important;
  }
  .p-button-icon-only {
    border-radius: 50px !important;
  }
  .vuejs3-datepicker__calendar {
    position: relative !important;
  }
  .flex-container {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  .flex-item-left {
    flex: 50%;
  }

  .flex-item-right {
    flex: 50%;
    text-align: right;
  }
</style>